<template>
    <div class=link-btn>
        [<a @click="exportFilteredDisplayable(props.dataToDownload, props.fileName)">Export csv</a>]
    </div>
</template>
<script setup lang="ts" generic="T extends object, K extends keyof T">
import DbTableCsvHelper from '@/services/helpers/DbTableCsvHelper';
import useNotifier from "@/services/composables/Notifier";
const props = defineProps<{
    dataToDownload: T[];
    columnsToRemove?: K[];
    fileName: string;
}>();
function exportFilteredDisplayable(dataToDownload: T[], fileName: string) {
    if (!dataToDownload.length) {
        useNotifier().warn({ msg: 'There is nothing in the table to export.' });
        return;
    }

    let filteredData = dataToDownload;

    if (props.columnsToRemove?.length) {
        filteredData = dataToDownload.map((item) => {
            const copy = { ...item };
            for (const key of props.columnsToRemove!) {
                delete copy[key];
            }
            return copy;
        });
    }

    DbTableCsvHelper.generateCsvDownload(filteredData, fileName);
}
</script>
<style scoped lang="scss">
.link-btn {
    margin-left: auto;
    padding: 0.1rem;
}
.link-btn > a {
    cursor: pointer;
    color: var(--theme-link-color);
    &:hover {
        text-decoration: underline;
        color: var(--theme-link-color-hover);
    }
}
</style>